.wrapper {
  flex-direction: column;
  height: 100%;
}

.deployer-grid-content {
  flex-grow: 2;
  height: 100%;

  .deployer-grid {
    height: 100%;
  }

  gz-grid-view {
    min-height: 100%;
    align-items: stretch;

    .inline-block {
      display: inline-block;
    }
  }
}

.info-box-style::part(container) {
  padding: unset;
  width: 870px;
}

gz-info-box {
  padding: calc(2 * var(--spacer)) 0 0;
  line-height: 18px;
  --info-box-max-width: 1148px;
}

.grid-wrapper {
  justify-content: space-evenly;
  position: relative;
  height: 33em;
  width: 1148px;
}
